import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons';
import s from '../CaseFilePage.module.css';

interface Note {
  NoteID: string | number;
  Date: string;
  Time?: string;
  Solicitor: string;
  Note: string;
}

interface NotesTableProps {
  notes: Note[];
  fmtUKDate: (val: unknown) => string;
}

export default function NotesTable({ notes, fmtUKDate }: NotesTableProps) {
  return (
    <div className={s.section}>
      <div className={s.sectionHeader}>
        <h3>
          <FontAwesomeIcon icon={faStickyNote} /> Case Notes
        </h3>
        <span className={s.badge}>{notes.length}</span>
      </div>

      {notes.length === 0 ? (
        <p className={s.emptyMsg}>No notes for this case.</p>
      ) : (
        <div className={s.tableScroll}>
          <table className={s.dataTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Note By</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {notes.map((n) => (
                <tr key={n.NoteID}>
                  <td className={s.nowrap}>{fmtUKDate(n.Date)}</td>
                  <td className={s.nowrap}>{n.Time || '—'}</td>
                  <td className={s.nowrap}>{n.Solicitor}</td>
                  <td>{n.Note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
